import { defaultThClass, defaultThStyle } from '../../config'

const defaultClass = {
  tdClass: 'font-[400] text-[#333333] !text-[12px]',
  class: `${defaultThClass} !text-[#333333]`,
}

export const optionStatusType = [
  {
    value: 'all',
    text: 'Semua Data',
  },
  {
    value: 'pending',
    text: 'Diajukan',
  },
  {
    value: 'completed',
    text: 'Selesai',
  },
  {
    value: 'rejected',
    text: 'Ditolak',
  },
]

export const fieldsRequestPackingTable = [
  {
    key: 'submission_time',
    label: 'Waktu Pengajuan',
    thStyle: {
      ...defaultThStyle,
      fontSize: '12px',
      minWidth: '190px',
    },
    ...defaultClass,
  },
  {
    key: 'warehouse',
    label: 'Mitra Gudang',
    thStyle: {
      ...defaultThStyle,
      fontSize: '12px',
      minWidth: '350px',
    },
    ...defaultClass,
  },
  {
    key: 'partner',
    label: 'Partner',
    thStyle: {
      ...defaultThStyle,
      fontSize: '12px',
      minWidth: '300px',
    },
    ...defaultClass,
  },
  {
    key: 'status',
    label: 'Status Packing',
    thStyle: {
      ...defaultThStyle,
      fontSize: '12px',
      minWidth: '213px',
    },
    ...defaultClass,
  },
  {
    key: 'mitra_contact',
    label: 'Kontak Mitra',
    thStyle: {
      ...defaultThStyle,
      fontSize: '12px',
      minWidth: '213px',
    },
    ...defaultClass,
  },
]
